export default {
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
};
